module.exports = __webpack_public_path__ + "img/rebuild_yeh_mob3.471f4729.jpg";